import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './assets/index.css';
import './assets/icons'; // semua icon ngumpul di sini
import { createPinia } from 'pinia';

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { LocalNotifications } from '@capacitor/local-notifications';
// import { Camera } from '@capacitor/camera';
// import { Capacitor } from '@capacitor/core';
import 'register-service-worker';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
LocalNotifications.requestPermissions();
// Camera.requestPermissions();
// if (!Capacitor.isNativePlatform()) {
//   Notification.requestPermission();
// }

createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(store)
  .use(router)
  .use(pinia)
  .mount('#app');
